import type { SolutionSubpageSlug } from './types';

export interface SolutionHeroWidget {
  kind: 'alert' | 'gauge' | 'status';
  badge: string;
  label: string;
  value: string;
  unit?: string;
  tone: 'red' | 'green' | 'blue';
  position: 'top-left' | 'top-right' | 'bottom-left' | 'bottom-right';
}

export const solutionHeroWidgets: Partial<Record<SolutionSubpageSlug, readonly SolutionHeroWidget[]>> = {
};
